import { useState } from 'react';
import { __ } from '@wordpress/i18n';
import { Button, Dashicon } from '@wordpress/components';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';

import './ItemsPanel.scss';
import { closeIcon, copyIcon, gripIcon } from '../utils/icons';

const DragHandle = SortableHandle(() => <div className='gripIcon'>{gripIcon}</div>);

const SortableItem = SortableElement(({ sortIndex: index, removeItem, duplicateItem, ItemSettings, active, setActive, itemLabel, ...props }) => {
	const { attributes, arrKey } = props;
	const items = attributes[arrKey];

	return <div className='bPlItemsPanelItem'>
		<div className='itemsPanelHeader mt10'>
			<DragHandle />

			<div className='panel-header-title'>
				<p onClick={() => setActive(active === index ? null : index)}>
					{itemLabel + ' ' + (index + 1)}
				</p>

				<div className='itemAction'>
					<div onClick={e => duplicateItem(e, index)}>{copyIcon}</div>

					{items.length > 1 && <div onClick={e => removeItem(e, index)}>{closeIcon}</div>}
				</div>
			</div>
		</div>

		<div className={`itemsPanelBody ${active === index ? '' : 'hidden'}`}>
			<ItemSettings {...props} index={index} />
		</div>
	</div>
});

const SortableList = SortableContainer((props) => {
	const { attributes, arrKey } = props;
	const items = attributes[arrKey];

	return <div className='bPlItemsPanel'>
		{items.map((__, index) => <SortableItem key={index} index={index} sortIndex={index}	{...props} />)}
	</div>
});

const ItemsPanel = (properties) => {
	const { attributes, setAttributes, arrKey, newItem, ItemSettings, itemLabel = 'Item', setActiveIndex = false, ...restProps } = properties;
	const items = attributes[arrKey];

	const [active, setActive] = useState(0);

	const addNewItem = () => {
		setAttributes({ [arrKey]: [...items, newItem] });

		setActiveIndex && setActiveIndex(items.length);
	};

	const duplicateItem = (e, index) => {
		e.preventDefault();

		setAttributes({ [arrKey]: [...items.slice(0, index), { ...items[index] }, ...items.slice(index)] });

		setActiveIndex && setActiveIndex(index + 1);
	}

	const removeItem = (e, index) => {
		e.preventDefault();

		setAttributes({ [arrKey]: [...items.slice(0, index), ...items.slice(index + 1)] });

		setActiveIndex && setActiveIndex(0 === index ? 0 : index - 1);
	}

	const onSortEnd = ({ oldIndex, newIndex }) => {
		setAttributes({ [arrKey]: arrayMove(items, oldIndex, newIndex) });
	};

	const props = {
		onSortEnd,
		attributes,
		setAttributes,
		arrKey,
		...restProps,
		ItemSettings,
		removeItem,
		duplicateItem,
		itemLabel,
		setActiveIndex,
		active,
		setActive
	}

	return <>
		<SortableList useDragHandle {...props} />

		<div className='addItem mt15'>
			<Button label={__(`Add New`, 'bplugins') + ' ' + itemLabel} onClick={addNewItem}><Dashicon icon='plus' />{__(`Add New`, 'bplugins') + ' ' + itemLabel}</Button>
		</div>
	</>
};
export default ItemsPanel;